const module_name = "service.user";

const $inject = ["$http", "PhpPolyfillObject"];

class UserService {
  /**
   * @param $http
   * @param {PhpPolyfillObject} PhpPolyfillObject
   */
  constructor($http, PhpPolyfillObject) {
    this.$http = $http;
    this.PhpPolyfillObject = PhpPolyfillObject;
  }

  load() {
    let handleSuccess = function (response) {
      return response.data.data;
    };

    let handleError = function (response) {
    };

    return this.$http
      .get("/admin/user/roles/get")
      .then(handleSuccess, handleError);
  }

  save_user_roles(users, handleSuccess, handleError) {
    return this.$http
      .post("/admin/user/roles/save", {
        users,
      })
      .then(handleSuccess, handleError);
  }
}

UserService.$inject = $inject;

export default angular.module(module_name, [])
  .service("UserService", UserService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/user.service.js
 **/